import script from "./AccountingMonthSwitch.vue?vue&type=script&setup=true&lang=js"
export * from "./AccountingMonthSwitch.vue?vue&type=script&setup=true&lang=js"

import "./AccountingMonthSwitch.vue?vue&type=style&index=0&id=54c3b46d&scoped=true&lang=scss"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-54c3b46d"]])

export default __exports__